import { Assert } from "../../../../../Assert";
import { PartialNullable } from "../../../../../Extensions";
import { $$, IJNativeEvent } from "../../../../../JNative";
import { PermissionCacheService } from "../../../../../PermissionCacheService";
import { PropertyChange } from "../../../../../PropertyChange";
import { Property, PropertyString } from "../../../../../RadObject";
import { ServiceManager } from "../../../../../ServiceManager";
import { Evaluator } from "../../../SeriouslyRAD.Framework/Evaluation/Evaluator";
import { EvaluatorPropertyValues, IEvaluator } from "../../../SeriouslyRAD.Framework/Evaluation/IEvaluator";
import { NAMESPACE } from "./_Namespace";

export type TeamEvaluatorPropertyValues =
    EvaluatorPropertyValues
    & {
        teamName: string;
    };

export type TeamEvaluatorProperties = {
    [name in keyof TeamEvaluatorPropertyValues]: Property<TeamEvaluatorPropertyValues[name]>
};

export interface ITeamEvaluator extends IEvaluator, TeamEvaluatorProperties
{
}

export class TeamEvaluator extends Evaluator<TeamEvaluatorPropertyValues> implements ITeamEvaluator
{
    public static override classNamespace = NAMESPACE + "TeamEvaluator";
    public static override className = "TeamEvaluator";

    // #region Properties

    public teamName!: PropertyString;

    // #endregion

    // #region Constructor

    constructor(propertyValues?: PartialNullable<TeamEvaluatorPropertyValues>)
    {
        super(propertyValues);

        $$(document).on("SeriouslyRAD.PermissionCache:PermissionsChanged", { self: this }, this.onPermissionsChanged);
    }

    // #endregion

    // #region Protected Methods

    protected _teamNameChanged(change: PropertyChange<string>)
    {
        /* Intentionally empty */
    }

    // #endregion

    // #region Overrides

    protected override __initializeProperties(propertyValues: TeamEvaluatorPropertyValues)
    {
        super.__initializeProperties(propertyValues);

        this.teamName = new PropertyString(this, propertyValues.teamName, this._teamNameChanged);
    }

    public override clone(): this
    {
        const
            evaluator = super.clone() as this;

        evaluator.teamName.set(this.teamName.get());

        return evaluator;
    }
    public override evaluate()
    {
        const
            teamName = this.teamName.get();

        Assert.isNotNullOrUndefined(teamName, "teamName");

        const
            permissionCache = ServiceManager.getOptional(PermissionCacheService),
            value =
                permissionCache
                    ? permissionCache.isInTeam(teamName)
                    : false;

        this.value.set(value);

        return value;
    }

    // #endregion

    // #region Event Handlers

    protected onPermissionsChanged(evt: IJNativeEvent)
    {
        const
            self = evt.data.self as this;

        self.evaluate();
    }

    // #endregion
}

